import { render, staticRenderFns } from "./PrintPosTk.vue?vue&type=template&id=ddaed54e&scoped=true"
import script from "./PrintPosTk.vue?vue&type=script&lang=js"
export * from "./PrintPosTk.vue?vue&type=script&lang=js"
import style0 from "./PrintPosTk.vue?vue&type=style&index=0&id=ddaed54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaed54e",
  null
  
)

export default component.exports